import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu } from 'antd';
import DiscussionTopic from './DiscussionTopic';

const { Content, Sider } = Layout;

class DiscussionGroup extends Component {
  state = {
    selectedTopicId: null,
  };

  onTopicSelect = ({ key }) => {
    this.setState({
      selectedTopicId: parseInt(key, 10),
    });
  };

  render() {
    const { topics, refetchQuery } = this.props;
    const { selectedTopicId } = this.state;
    return (
      <Layout style={{ background: '#fff' }}>
        <Sider width={400} style={{ background: '#fff' }}>
          <Menu
            mode="inline"
            style={{ height: '100%' }}
            selectedKeys={[`${selectedTopicId}`]}
            onSelect={this.onTopicSelect}
          >
            {topics.map((entry) => (
              <Menu.Item key={entry.id}>{entry.title}</Menu.Item>
            ))}
          </Menu>
        </Sider>
        <Content style={{ padding: '0 24px' }}>
          {selectedTopicId ? (
            <DiscussionTopic topic={topics.find((entry) => entry.id === selectedTopicId)} refetchQuery={refetchQuery} />
          ) : (
            <p>Select a topic.</p>
          )}
        </Content>
      </Layout>
    );
  }
}

DiscussionGroup.propTypes = {
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  refetchQuery: PropTypes.func.isRequired,
};

export default DiscussionGroup;



// WEBPACK FOOTER //
// ./src/components/DiscussionGroup.jsx